import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "hamburger-menu_fc3bab815d60481697c1332bc443786e",
  "use": "hamburger-menu_fc3bab815d60481697c1332bc443786e-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"hamburger-menu_fc3bab815d60481697c1332bc443786e\">\n<path d=\"M3 7H21\" stroke=\"#B4B4B4\" stroke-width=\"1.5\" stroke-linecap=\"round\" />\n<path d=\"M3 12H21\" stroke=\"#B4B4B4\" stroke-width=\"1.5\" stroke-linecap=\"round\" />\n<path d=\"M3 17H21\" stroke=\"#B4B4B4\" stroke-width=\"1.5\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol